import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";
type UpdateCoursePayload = {
    id: number;
    data: {
        title: string,
        description: string,
        duration: number,
        price: number,
        prerequisiteCourseIds: Array<number>
    };
};

export const useUpdateCourse = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: UpdateCoursePayload) =>
            adminApi.updateCourse(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["courses"],
            });
        },
    });
};

